<div class="fixed-top">
  <div class="d-flex flex-column">
    <app-header #header></app-header>
    <app-breadcrumb></app-breadcrumb>
  </div>
</div>

<div class="wrapper">
  <div class="main-text my-3  justify-content-between myRequestsFilter">
    <div class="float">
      <div>
        <mat-form-field class="custom_select mr-2 custom_select_checkbox_chips custom_date_picker" appearance="outline" style="max-width:200px !important">
            <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                <input matStartDate formControlName="start" placeholder="Start date" [(ngModel)]="startDate">
                <input matEndDate formControlName="end" placeholder="End date" [(ngModel)]="endDate">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker>
                <mat-date-range-picker-actions>
                    <button mat-button matDateRangePickerCancel (click)="clearDateRange()">Cancel</button>
                    <button mat-raised-button color="primary" matDateRangePickerApply (click)="applyDateRange()">Apply</button>
                </mat-date-range-picker-actions>
            </mat-date-range-picker>

            <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start
                date</mat-error>
            <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end
                date</mat-error>
        </mat-form-field>
      </div>
      <mat-form-field class="custom_select mr-2" style="max-width:200px !important">
        <mat-select [(ngModel)]="this.names" (selectionChange)="filterDataByNames($event)"
         placeholder="Assigneed To" multiple>
         <div class="search-bar width">
         <button type="submit" class="msicon"><span class="material-symbols-outlined">
          search</span></button>
          <input type="text" mat-input class="form-control search-Text" [(ngModel)]="input"(keyup)="onSearch($event.target.value)" placeholder="Search">
          <button type="submit" class="msicon bg-color" *ngIf="input"(click)="clearSearch()" ><span
            class="material-symbols-outlined"> close </span></button>
            </div>
          <mat-select-trigger>
            {{names?.[0] || ''}}
            <span *ngIf="names?.length>1" class="example-additional-selection">
              (+{{(names?.length || 0) - 1}} {{names?.length === 2 ? 'other' : 'others'}})
            </span>
          </mat-select-trigger>
          <mat-option  [value]="'Select All'"><span >Select All</span> </mat-option>
          <mat-option *ngFor="let data of teamMembers" [value]="data">{{data}}</mat-option>
          <button style="float:right;"mat-flat-button (click)="clear()">clear</button>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="custom_select ">
        <mat-select [(value)]="selectedStatus" (selectionChange)="filterDataByStatus($event.value)"
          placeholder="Status" multiple>
          <mat-select-trigger>
            {{selectedStatus?.[0] || ''}}
            <span *ngIf="selectedStatus.length>1" class="example-additional-selection">
              (+{{(selectedStatus?.length || 0) - 1}} {{selectedStatus?.length === 2 ? 'other' : 'others'}})
            </span>
          </mat-select-trigger>
          <mat-option *ngFor="let data of (status|keyvalue)" [value]="data.key">{{data.key}}</mat-option>
        </mat-select>
      </mat-form-field>

    </div>

  </div>
  <div class="table-container mat-elevation-z8">
    <mat-table #table [dataSource]="dataStore[0]?.data.length > 0  ? dataStore[0] : emptyData">

      <ng-container matColumnDef="Employee Name">
        <mat-header-cell *matHeaderCellDef class="header-cell"> Assigned To</mat-header-cell>
        <mat-cell *matCellDef="let element" class="sub-cell"> {{element.employeeName}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Course Name">
        <mat-header-cell *matHeaderCellDef class="header-cell"> Program Name </mat-header-cell>
        <mat-cell *matCellDef="let element" class="sub-cell"> {{element.courseName}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Status">
        <mat-header-cell *matHeaderCellDef class="header-cell"> Status </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div id="prog-name" class="sub-cell">{{element.status}}</div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="empty-row">
        <mat-cell class="center" *matCellDef="let element" >
          <div class="noDataCard mt-0">
            <div class="noDataCardIn">
              <img src="../../../assets/images/no_data.png" height="120px"><br>
              <span class="mt-3 d-block"> No Records Found</span> 
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="teamCourseColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: dataStore[0]?.data.length > 0 ? teamCourseColumns : ['empty-row'];">
      </mat-row>

    </mat-table>
    <div id="pagination">
      <app-pagination [currentPage]="PageNo" [pageSize]="pageSize" [total]="totalRecords"
        (pageChange)="changePage($event)"></app-pagination>
    </div>
  </div>

</div>